export default __webpack_public_path__ + "static/media/investigacion.cce755ac.png";